import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { projectConfigApi } from '../../../lib/project-config-api.js';
import { useCurrentProject } from '../../../lib/use-project.js';

// Plan 7 / Task F4 (GAM-1: "dezent, professionell, abschaltbar"): ein einzelner Schalter genügt —
// kein Speichern-Button. Sofortiger PATCH bei jeder Änderung (analog notification-settings.tsx),
// damit der Zustand nie zwischen UI und Server auseinanderläuft.
export function GamificationPanel() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { project, isLoading: projectLoading } = useCurrentProject();
  const projectId = project?.project_id;

  const query = useQuery({
    queryKey: ['project-settings', projectId],
    queryFn: () => projectConfigApi.getSettings(projectId ?? ''),
    enabled: Boolean(projectId),
  });

  const patch = useMutation({
    mutationFn: (gamification_enabled: boolean) =>
      projectConfigApi.patchSettings(projectId ?? '', { gamification_enabled }),
    meta: { successToast: 'feedback.saved' },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['project-settings', projectId] });
    },
  });

  if (projectLoading) {
    return <div className="p-6 text-text-muted">{t('common.loading')}</div>;
  }
  if (!project || !projectId) {
    return <div className="p-6 text-text-muted">{t('catalog.noProject')}</div>;
  }

  return (
    <div className="space-y-4 p-6">
      <h2 className="text-lg font-bold text-text-primary">{t('admin.gamification')}</h2>
      <section className="rounded-card border border-[var(--border)] bg-bg-surface p-4">
        <label className="flex items-center gap-3 text-sm text-text-body">
          <input
            type="checkbox"
            checked={query.data?.gamification_enabled ?? true}
            disabled={query.isLoading || patch.isPending}
            onChange={(e) => patch.mutate(e.target.checked)}
          />
          <span>{t('admin.gam.enabledLabel')}</span>
        </label>
      </section>
    </div>
  );
}
